import {gsap} from "../LibrariesImport";
import {GlobalVariables} from "../GlobalVariables";

export default class LabModal {
    static ICONS = {
        linkedin: `<svg viewBox="0 0 448 512" width="14"><path d="M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 1 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.7-48.3 87.9-48.3 94 0 111.3 61.9 111.3 142.3V448z"/></svg>`,
        link: `<svg width="14" height="14" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M26.793 16.4995L22.1263 21.1662C19.793 23.5412 15.9596 23.5412 13.6263 21.1662C11.543 19.0829 11.2513 15.8329 12.9596 13.4162L13.0013 13.3745C13.4596 12.7495 14.293 12.6245 14.8763 13.0412C15.4596 13.4579 15.6263 14.2912 15.168 14.9162L15.1263 14.9579C14.168 16.2912 14.3346 18.1245 15.5013 19.2912C16.793 20.6245 18.918 20.6245 20.2513 19.2912L24.918 14.6245C26.2513 13.2912 26.2513 11.1662 24.918 9.87454C23.7513 8.70788 21.918 8.54121 20.5846 9.49954L20.543 9.54121C19.918 9.99954 19.0846 9.83288 18.668 9.24954C18.2513 8.66621 18.3763 7.83288 18.9596 7.37454L19.043 7.33288C21.4596 5.62454 24.7096 5.91621 26.793 7.99954C29.168 10.3329 29.168 14.1662 26.793 16.4995ZM5.16797 15.5412L9.83464 10.8329C12.2096 8.49954 16.0013 8.49954 18.3763 10.8329C20.4596 12.9162 20.7096 16.2079 19.0013 18.6245L18.9596 18.6662C18.543 19.2912 17.668 19.4162 17.0846 18.9995C16.5013 18.5829 16.3346 17.7495 16.793 17.1245L16.8346 17.0829C17.793 15.7079 17.6263 13.9162 16.4596 12.7495C15.168 11.4162 13.043 11.4162 11.7096 12.7495L7.04297 17.4162C5.7513 18.7079 5.7513 20.8329 7.04297 22.1662C8.20964 23.3329 10.043 23.4995 11.3763 22.5412L11.418 22.4995C12.043 22.0412 12.8763 22.2079 13.293 22.7912C13.7096 23.3745 13.5846 24.2079 13.0013 24.6662L12.918 24.7079C10.543 26.4162 7.2513 26.1245 5.16797 24.0412C2.79297 21.7079 2.79297 17.8745 5.16797 15.5412Z" fill="currentColor"/></svg>`,
        close: `<svg viewBox="0 0 320 512" width="16"><path d="M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z"/></svg>`,
        arrowRight: `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 8h11M9 4l4 4-4 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
        go: `<svg width="50" height="54" viewBox="0 0 50 54" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.7803 49.6981L23.5981 53.5714L50 26.7857L23.5981 0L19.7803 3.87236L39.6649 24.046L0 24.046L0 29.5239L39.6649 29.5239L19.7803 49.6981Z" fill="currentColor"/></svg>`
    };

    static init() {
        this.overlay = document.getElementById('lab-modal-overlay');
        this.container = document.getElementById('lab-modal-container');
        this.originImg = null;

        if (this.overlay && this.container) {
            this.bindEvents();
            this.preloadAllImages();
        }
    }

    // ... (preloadAllImages et bindEvents restent inchangés) ...
    static preloadAllImages() {
        const cards = document.querySelectorAll('.project_lab-card');
        cards.forEach(card => {
            try {
                const data = JSON.parse(card.getAttribute('data-project-json'));
                if (data.image_src) {
                    const img = new Image();
                    img.src = data.image_src;
                }
            } catch (e) {
                console.error("Erreur preload JSON", e);
            }
        });
    }

    static bindEvents() {
        document.addEventListener('click', (e) => {
            const card = e.target.closest('.project_lab-card');
            if (card && e.target.closest('a[data-lab-modal="true"]')) {
                e.preventDefault();
                const data = JSON.parse(card.getAttribute('data-project-json'));
                this.openModal(data, card.querySelector('.image img'));
            }
            if (e.target.closest('.lab-close-btn') || e.target.classList.contains('lab-modal-backdrop')) {
                this.closeModal();
            }
        });
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') this.closeModal();
        });
    }

    static openModal(data, clickedImg) {
        this.originImg = clickedImg;

        this.overlay.style.display = 'flex';
        document.body.style.overflow = 'hidden';
        if (GlobalVariables.lenis) GlobalVariables.lenis.stop();

        this.container.innerHTML = this.generateModalHTML(data);

        const isMobile = window.innerWidth < 992;

        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                const targetImg = this.container.querySelector('.lab-modal-image');
                const colInfos = this.container.querySelector('.col-infos');

                // === ANIMATION MOBILE (SHEET DU BAS) ===
                if (isMobile) {
                    // 1. Initialisation : Container hors écran vers le bas
                    gsap.set(this.container, { y: '100%', opacity: 1 });

                    // 2. Timeline d'ouverture
                    const tl = gsap.timeline();

                    // Fade In Overlay
                    tl.to(this.overlay, { opacity: 1, duration: 0.3 }, 0);

                    // Slide Up Container (effet sheet)
                    tl.to(this.container, {
                        y: '0%',
                        duration: 0.5,
                        ease: "power3.out"
                    }, 0.1);

                }
                // === ANIMATION DESKTOP (ORIGINALE) ===
                else {
                    targetImg.style.opacity = '0';

                    if (clickedImg) {
                        const rect = clickedImg.getBoundingClientRect();
                        const clone = clickedImg.cloneNode(true);

                        if (data.image_src) clone.src = data.image_src;

                        Object.assign(clone.style, {
                            position: 'fixed',
                            top: `${rect.top}px`,
                            left: `${rect.left}px`,
                            width: `${rect.width}px`,
                            height: `${rect.height}px`,
                            zIndex: '10000',
                            pointerEvents: 'none',
                            objectFit: 'cover',
                            borderRadius: '1rem',
                            transition: 'none'
                        });

                        document.body.appendChild(clone);
                        const targetRect = targetImg.getBoundingClientRect();

                        const tl = gsap.timeline();

                        tl.fromTo(this.overlay, {opacity: 0}, {opacity: 1, duration: 0.3}, 0)
                            .to(clone, {
                                top: targetRect.top,
                                left: targetRect.left,
                                width: targetRect.width,
                                height: targetRect.height,
                                duration: 0.3,
                                ease: "power1.out",
                                onStart: () => {
                                    clickedImg.style.opacity = '0';
                                },
                                onComplete: () => {
                                    if (targetImg.complete) {
                                        targetImg.style.opacity = '1';
                                        clone.remove();
                                    } else {
                                        targetImg.onload = () => {
                                            gsap.to(targetImg, {opacity: 1, duration: 0.3});
                                            gsap.to(clone, {opacity: 0, duration: 0.3, onComplete: () => clone.remove()});
                                        };
                                    }
                                }
                            }, 0)
                            .fromTo(colInfos, {opacity: 0, y: 20}, {opacity: 1, y: 0, duration: 0.4}, 0.3);
                    } else {
                        gsap.to(this.overlay, {opacity: 1, duration: 0.3});
                        gsap.fromTo(colInfos, {opacity: 0, y: 20}, {opacity: 1, y: 0, duration: 0.4, delay: 0.1});
                        targetImg.style.opacity = '1';
                    }
                }
            });
        });
    }

    static closeModal() {
        const modalImg = this.container.querySelector('.lab-modal-image');
        const colInfos = this.container.querySelector('.col-infos');
        const isMobile = window.innerWidth < 992;

        const onAnimationComplete = () => {
            if (this.originImg) this.originImg.style.opacity = '1';
            this.overlay.style.display = 'none';
            document.body.style.overflow = '';
            if (GlobalVariables.lenis) GlobalVariables.lenis.start();
            this.container.innerHTML = '';
            // Reset des styles inline qui auraient pu être ajoutés par GSAP
            gsap.set(this.container, { clearProps: "all" });
            this.originImg = null;
        };

        // === FERMETURE MOBILE ===
        if (isMobile) {
            const tl = gsap.timeline({ onComplete: onAnimationComplete });

            // Slide Down
            tl.to(this.container, {
                y: '100%',
                duration: 0.3,
                ease: "power3.in"
            }, 0);

            // Fade Out Overlay
            tl.to(this.overlay, { opacity: 0, duration: 0.3 }, 0.1);
        }
        // === FERMETURE DESKTOP ===
        else if (this.originImg && modalImg) {
            // ... (Code fermeture desktop existant) ...
            const startRect = modalImg.getBoundingClientRect();
            const endRect = this.originImg.getBoundingClientRect();

            const clone = modalImg.cloneNode(true);
            Object.assign(clone.style, {
                position: 'fixed',
                top: `${startRect.top}px`,
                left: `${startRect.left}px`,
                width: `${startRect.width}px`,
                height: `${startRect.height}px`,
                zIndex: '10000',
                objectFit: 'cover',
                borderRadius: '1rem',
                pointerEvents: 'none',
                transition: 'none'
            });

            document.body.appendChild(clone);
            modalImg.style.visibility = 'hidden';

            const tl = gsap.timeline({
                onComplete: () => {
                    if (this.originImg) this.originImg.style.opacity = '1';
                    clone.remove();
                    onAnimationComplete();
                }
            });

            tl.to([this.overlay, colInfos], {opacity: 0, duration: 0.2, ease: "linear"}, 0);

            tl.to(clone, {
                top: endRect.top,
                left: endRect.left,
                width: endRect.width,
                height: endRect.height,
                duration: 0.3,
                ease: "power1.out"
            }, 0);

        } else {
            // Fallback simple
            gsap.to(this.overlay, {
                opacity: 0,
                duration: 0.3,
                onComplete: onAnimationComplete
            });
        }
    }

    // ... (generateModalHTML reste inchangé) ...
    static generateModalHTML(data) {
        // ... (Code existant inchangé)
        const isPortrait = parseInt(data.image_height) > parseInt(data.image_width);
        const formatClass = isPortrait ? 'format-portrait' : 'format-landscape';

        const tagsHTML = data.tags.map(t => `<span class="tag tag-${t.type} text-uppercase">${t.name}</span>`).join('');

        const teamHTML = data.team.map(m => `
        <li class="team-member">
            ${m.linkedin ? `<a href="${m.linkedin}" target="_blank" class="d-flex align-items-center w-100 text-decoration-none">` : `<div class="d-flex align-items-center w-100">`}
                <span class="member-name regular">${m.name}</span>
                <span class="member-line" ${!m.linkedin ? 'style="opacity: 0.3;"' : ''}></span>
                <span class="member-link" ${!m.linkedin ? 'style="opacity: 0.3;"' : ''}>${this.ICONS.linkedin}</span>
            ${m.linkedin ? `</a>` : `</div>`}
        </li>`).join('');

        const resourcesHTML = data.resources.map(r => `
        <li class="team-member mb-2">
            <a href="${r.url}" target="_blank" class="d-flex align-items-center w-100 text-decoration-none pt-0 lh-1">
                <span class="member-name regular">${r.label}</span>
                <span class="member-line flex-grow-1 mx-2" style="opacity: 0.3; border-bottom: 1px solid currentColor;"></span>
                <span class="member-link resource-icon">${this.ICONS.link}</span>
            </a>
        </li>`).join('');

        const mobileCtaHTML = data.link ? `
        <div class="lab-section lab-modal-cta-mobile-wrap px-3 px-md-1">
            <a href="${data.link}" target="_blank" rel="noopener" class="btn-fill btn-go btn-header lab-modal-cta-mobile">
                <span class="label">Voir le projet</span>
                <span class="svg">${this.ICONS.go}</span>
            </a>
        </div>` : '';

        return `
    <div class="lab-modal-content">
        <div class="lab-modal-mobile-header">
            <span class="lab-modal-apercu">Aperçu</span>
            <button class="lab-close-btn lab-close-btn-mobile">${this.ICONS.close}</button>
        </div>
        <div class="row gx-half h-100">
            <div class="col-lg-14 order-0 text-center col-media mb-2 mb-md-0 ${formatClass}">
                ${data.link ? `<a href="${data.link}" target="_blank" rel="noopener" class="lab-modal-image-link">` : ''}
                <img src="${data.image_src}"
                     width="${data.image_width}"
                     height="${data.image_height}"
                     class="lab-modal-image"
                     loading="eager"
                     decoding="sync"
                     fetchpriority="high">
                ${data.link ? `<span class="lab-modal-image-cta">Voir le projet ${this.ICONS.arrowRight}</span></a>` : ''}
            </div>

            <div class="col-hyper-10 col-lg-8 order-1 gx-2 pt-2 col-infos" data-lenis-prevent>
                <div class="infos-wrapper">
                    <h2 class="title-level-2 lab-modal-title px-2 px-md-1">${data.title}</h2>
                    ${data.tags.length ? `<div class="d-flex gap-2 flex-wrap mb-half px-2 px-md-1">${tagsHTML}</div>` : ''}
                    ${data.team.length ? `<div class="lab-section mb-3 mb-md-4 row"><h3 class="lab-label mb-2 emphasized col-24 px-3 px-md-1">Réalisé par</h3><ul class="lab-team-list col-24 col-md-16 px-3 px-md-1">${teamHTML}</ul></div>` : ''}
                    ${mobileCtaHTML}
                    ${data.concept ? `<div class="lab-section mb-3 mb-md-4 row"><h3 class="lab-label mb-2 emphasized col-24 px-3 px-md-1">Concept</h3><div class="lab-text col-24 col-md-16 px-3 px-md-1">${data.concept}</div></div>` : ''}
                    ${data.resources.length ? `<div class="lab-section row"><h3 class="lab-label mb-2 emphasized col-24 px-3 px-md-1">Ressources</h3><div class=" col-24 col-md-16 px-3 px-md-1"><ul class="lab-team-list">${resourcesHTML}</ul></div></div>` : ''}
                </div>
            </div>
        </div>
        <button class="lab-close-btn lab-close-btn-bottom">Fermer<span class="svg ms-2">${this.ICONS.close}</span></button>
    </div>
    `;
    }
}